import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  height: 100%;
`

export const ImageStyled = styled.div`
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
`

export const ContentContainer = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  height: 100%;
`
